import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Services from "../pages/services/page";
import About from "../pages/about/page";
import Insights from "../pages/insights/page";
import ArticleDetail from "../pages/insights/ArticleDetail";
import WhyChooseUs from "../pages/why-choose-us/page";
import Contact from "../pages/contact/page";
import DeploymentGuide from "../pages/deployment-guide/page";
import EmailSetup from "../pages/email-setup/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/services", element: <Services /> },
  { path: "/about", element: <About /> },
  { path: "/insights", element: <Insights /> },
  { path: "/insights/:slug", element: <ArticleDetail /> },
  { path: "/why-choose-us", element: <WhyChooseUs /> },
  { path: "/contact", element: <Contact /> },
  { path: "/deployment-guide", element: <DeploymentGuide /> },
  { path: "/email-setup", element: <EmailSetup /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
